module.exports = __webpack_public_path__ + "ce01c848b5a09253c376b0cbfdc47f4a.png";